module.exports = "<div class=\"emoji fn-hover\" ng-click=\"$ctrl.openSelector()\"></div>";